import { useGlobalStore } from '@/stores/global';

export type InContextDatas = {
  pseudoLang: string;
};

// todo change pour preprod
const PSEUDO_LANG = 'zu-ZA';

export function launchCrowdinInContext(): false | InContextDatas {
  const isInContext = new URLSearchParams(window.location.search).get('in-context');

  if (useGlobalStore().environment !== 'production' && isInContext !== null) {
    const script: HTMLScriptElement = document.createElement('script');
    script.src = '//cdn.crowdin.com/jipt/jipt.js';
    document.body.append(script);

    return {
      pseudoLang: PSEUDO_LANG,
    };
  }

  return false;
}
